import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
export default function useMousePosition() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      x: 0,
      y: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [mousePosition, setMousePosition] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleMouseMove = event => {
        setMousePosition({
          x: event.clientX,
          y: event.clientY
        });
      };
      window.addEventListener("mousemove", handleMouseMove);
      return () => {
        window.removeEventListener("mousemove", handleMouseMove);
      };
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return mousePosition;
}